var SMALL_SIZE = 'small';
var MEDIUM_SIZE = 'medium';
var LARGE_SIZE = 'large';
export var PEAK_SIZES = [SMALL_SIZE, MEDIUM_SIZE, LARGE_SIZE];
export var MAX_WIDTHS = [LARGE_SIZE];